import * as React from 'react';

import styled from 'styled-components';

import { ANIMATION, SPACING, SPEED } from '../../packages/constants';
import blackSpinner from './images/spinner-black';
import whiteSpinner from './images/spinner-white';

export interface LoadingSpinnerProps {
    children?: React.ReactNode;
    onClick?: (e: any) => void;
    color?: 'black' | 'white';
    justify?: 'flex-start' | 'center' | 'flex-end' | 'space-between' | undefined;
    iconWidth?: string;
    iconHeight?: string;
    className?: string;
}

export interface SpinnerIconProps {
    width?: string;
    height?: string;
}

const StyledLoadingSpinner = styled.div<LoadingSpinnerProps>`
    display: flex;
    align-items: center;
    justify-content: ${(props: LoadingSpinnerProps): string => (props.justify ? props.justify : 'space-between')};
`;

export const Icon = styled.img<SpinnerIconProps>`
    width: ${(props) => props.width};
    height: ${(props) => props.height};
    margin: 0 0 0 ${SPACING.SMALL};
    display: inline-block;
    animation: ${ANIMATION.ROTATE_CLOCKWISE} ${SPEED.ROTATE} linear infinite;
`;

export const LoadingSpinner = ({
    children,
    color = 'white',
    iconWidth = '20px',
    iconHeight = '20px',
    ...props
}: LoadingSpinnerProps) => (
    <StyledLoadingSpinner {...props}>
        {children}
        <Icon
            src={color === 'black' ? blackSpinner : whiteSpinner}
            alt={'Loading'}
            width={iconWidth}
            height={iconHeight}
        />
    </StyledLoadingSpinner>
);
